import React from "react";
import Review from "./Review";
import Loading from "../Shared/Loading";
import useReviews from "../../hooks/useReviews";

const Reviews = () => {
  const [reviews, isLoading] = useReviews([]);
  if (isLoading) {
    return <Loading></Loading>;
  }

  return (
    <section className="my-5 max-w-7xl mx-auto">
      <div className="text-center">
        <h2 className="lg:text-5xl text-3xl mb-10 font-bold text-accent">
          What our customer say
        </h2>
      </div>
      <div>
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 pt-10 px-10"
          // style={{
          //   backgroundImage:
          //     "url(https://i.ibb.co/fYQDqfx/mbaba-banner-Bg.png)",
          // }}
        >
          {reviews.map((review) => (
            <Review key={review._id} review={review}></Review>
          ))}
        </div>
        <div className="text-center py-10"></div>
      </div>
    </section>
  );
};

export default Reviews;
